/**
 * A class that can return the AppraisalTemplate model
 */
export class AppraisalTemplate {
  /** @param {Object} template FastJson object. */
  constructor(template = {}) {
    this.id = template.id || null;
    if (template.attributes) {
      this.name = template.attributes.name || null;
      this.description = template.attributes.description || null;
      this.status = template.attributes.status || null;
      this.createdById = template.attributes.created_by_id || null;
      this.createdAt = template.attributes.created_at || null;
      this.updatedAt = template.attributes.updated_at || null;
      this.inUse = template.attributes.in_use || false;
      this.canEdit = template.attributes.can_edit || false;
      this.questionsCount = template.attributes.questions_count || 0;
      this.scoredQuestionsCount = template.attributes.scored_questions_count || 0;
      this.totalWeight = template.attributes.total_weight || 0;
      this.questions = template.attributes.questions || [];
    }
  }
}
